import React, { } from 'react';
import './../../assets/styles/Footer.css'
import logoSvg from './../../assets/images/new/header_logo.png'

const Footer = ({ ignoreLogo = false }) => {
    return (
        <div id="footer" className="footer_container">
            {!ignoreLogo ? <div className="footer_box" style={{ backgroundImage: `url(${logoSvg})` }} /> : null}
            {/* <p>
                &copy; Copyright Graviola Digital {new Date().getFullYear()}<br />Todos direitos reservados.
            </p> */}
            <p className='text-center'>&copy; Copyright Graviola Digital {new Date().getFullYear()} sob autorização de Stenna <br /> Todos os direitos reservados.</p>
        </div>
    );
}

export const handleClick = event => {
    // window.open('www.google.com', '_blank')
}

export default Footer;
